import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("odm_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const BASE_RATE = 1.8;
export const ADDONS = [
  { key: "coats", label: "Extra Coat", pct: 10 },
  { key: "ceilings", label: "Ceilings", pct: 15 },
  { key: "trim", label: "Trim & Doors", pct: 10 },
];

export function computeEstimate(sqft, addons) {
  const base = (Number(sqft) || 0) * BASE_RATE;
  let mult = 1;
  ADDONS.forEach((a) => {
    if (addons[a.key]) mult += a.pct / 100;
  });
  return Math.round(base * mult * 100) / 100;
}
